import { Controller } from "@hotwired/stimulus"
import { createTurboDataTable, destroyTurboDataTable } from "lib/datatables_turbo"

export default class extends Controller {
  static targets = ["table"]

  static values = {
    ajaxUrl: String,
  }

  connect() {
    if (!this.hasTableTarget) return
    this.#initDataTable()
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable = destroyTurboDataTable(this.dataTable)
    }
  }

  #initDataTable() {
    this.dataTable = createTurboDataTable(this.tableTarget, {
      dom: "<fr>t<ip>",
      bSort: false,
      bPaginate: true,
      iDisplayLength: 10,
      stateSave: true,
      serverSide: true,
      processing: true,
      searchDelay: 2000,
      autoWidth: false,
      ordering: true,
      order: [3, "desc"],
      ajax: {
        url: this.ajaxUrlValue,
      },
      columnDefs: [
        { targets: [0, 1, 2, 3, 4, 5, 6, 7, 8], searchable: false },
        { targets: [0, 1, 2, 4, 5, 6, 7, 8], sortable: false },
      ],
    })
  }
}
